import {
    AddressForm,
    BackButton,
    Container,
    convertFromBoolean,
    convertToBoolean,
    Divider,
    Form,
    FormDropDown,
    FormInput,
    FormRadio,
    Header,
    SummaryGroup,
    setAttributeEntity,
    useAlignments,
    useSizes,
} from 'metrix-common3';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import ProfileDwellingAnimal from './Animal';
import ProfileDwellingGarage from './Garage';
import ProfileDwellingHeatingSystem from './HeatingSystem';
import ProfileDwellingImprovement from './Improvement';
import ProfileDwellingLossPayee from './LossPayee';
import ProfileDwellingScheduledItem from './ScheduledItem';
import ProfileDwellingSwimmingPool from './SwimmingPool';
import ProfileDwellingWaterMitigationSystem from './WaterMitigationSystem';

const ProfileDwelling = (props) => {
    const sizes = useSizes();
    const alignments = useAlignments();

    const [mode, setMode] = useState('dwelling');
    const [current, setCurrent] = useState(null);

    const getDwellingAnimals = () => {
        const dwellingAnimals = [];

        if (props.dwelling?.animals && props.dwelling.animals.length > 0) {
            props.dwelling.animals.forEach((animal) => {
                const option = { code: animal.type?.value, value: animal.guid };

                let animalName = 'New Animal';

                if (animal.type?.value) {
                    animalName = `${animal.type.value}`;

                    if (animal.breed?.value) {
                        animalName = `${animalName} (${animal.breed.value})`;
                    }
                }

                option.elements = [];

                option.elements.push({ code: 'Label', value: animalName });

                dwellingAnimals.push(option);
            });
        }

        return dwellingAnimals;
    };

    const getDwellingHeatingSystems = () => {
        const heatingSystems = [];

        if (props.dwelling?.heatingSystems && props.dwelling.heatingSystems.length > 0) {
            props.dwelling.heatingSystems.forEach((heatingSystem) => {
                const option = { code: heatingSystem.type?.value, value: heatingSystem.guid };

                let heatingSystemName = 'New Heating System';

                if (heatingSystem.type) {
                    heatingSystemName = `${heatingSystem.type.value}`;
                }

                if (`${heatingSystem.primary}` === `${true}`) {
                    heatingSystemName = `${heatingSystemName} (Primary)`;
                }

                option.elements = [];

                option.elements.push({ code: 'Label', value: heatingSystemName });

                heatingSystems.push(option);
            });
        }

        return heatingSystems;
    };

    const getDwellingWaterMitigationSystems = () => {
        const waterMitigationSystems = [];

        if (props.dwelling?.protection?.waterMitigations && props.dwelling.protection.waterMitigations.length > 0) {
            props.dwelling.protection.waterMitigations.forEach((waterMitigation) => {
                const option = {
                    code: waterMitigation.sumpPumpType?.value,
                    value: waterMitigation.guid,
                };

                let waterMitigationSystemName = 'New Water Mitigation System';

                if (waterMitigation.sumpPumpType) {
                    waterMitigationSystemName = `${waterMitigation.sumpPumpType.value}`;
                }

                if (`${waterMitigation.primary}` === `${true}`) {
                    waterMitigationSystemName = `${waterMitigationSystemName} (Primary)`;
                }

                option.elements = [];

                option.elements.push({ code: 'Label', value: waterMitigationSystemName });

                waterMitigationSystems.push(option);
            });
        }

        return waterMitigationSystems;
    };

    const getDwellingGarages = () => {
        const garages = [];

        if (props.dwelling?.garages && props.dwelling.garages.length > 0) {
            props.dwelling.garages.forEach((garage) => {
                const option = { code: garage.type?.value, value: garage.guid };

                let garageName = 'New Garage';

                if (garage.type) {
                    garageName = `${garage.type.value}`;
                }

                option.elements = [];

                option.elements.push({ code: 'Label', value: garageName });

                garages.push(option);
            });
        }

        return garages;
    };

    const getDwellingSwimmingPools = () => {
        const swimmingPools = [];

        if (props.dwelling?.swimmingPools && props.dwelling.swimmingPools.length > 0) {
            props.dwelling.swimmingPools.forEach((swimmingPool) => {
                const option = { code: swimmingPool.type?.value, value: swimmingPool.guid };

                let swimmingPoolName = 'New Swimming Pool';

                if (swimmingPool.type) {
                    swimmingPoolName = `${swimmingPool.type.value}`;
                }

                option.elements = [];

                option.elements.push({ code: 'Label', value: swimmingPoolName });

                swimmingPools.push(option);
            });
        }

        return swimmingPools;
    };

    const getDwellingScheduledItems = () => {
        const scheduledItems = [];

        if (props.dwelling?.scheduledItems && props.dwelling.scheduledItems.length > 0) {
            props.dwelling.scheduledItems.forEach((scheduledItem) => {
                const option = { code: scheduledItem.type?.value, value: scheduledItem.guid };

                let scheduledItemName = 'New Scheduled Item';

                if (scheduledItem.type) {
                    scheduledItemName = `${scheduledItem.type.value}`;
                }

                option.elements = [];

                option.elements.push({ code: 'Label', value: scheduledItemName });

                scheduledItems.push(option);
            });
        }

        return scheduledItems;
    };

    const getDwellingLossPayees = () => {
        const lossPayees = [];

        if (props.dwelling?.lossPayees && props.dwelling.lossPayees.length > 0) {
            props.dwelling.lossPayees.forEach((lossPayee) => {
                const option = { code: lossPayee.name, value: lossPayee.guid };

                let lossPayeeName = 'New Loss Payee';

                if (lossPayee.value) {
                    lossPayeeName = `${lossPayee.value}`;
                }

                option.elements = [];

                option.elements.push({ code: 'Label', value: lossPayeeName });

                lossPayees.push(option);
            });
        }

        return lossPayees;
    };

    const getDwellingImprovements = () => {
        const improvements = [];

        if (props.dwelling?.improvement?.otherImprovements && props.dwelling.improvement.otherImprovements.length > 0) {
            props.dwelling.improvement.otherImprovements.forEach((improvement) => {
                const option = { code: improvement.name, value: improvement.guid };

                let improvementName = 'New Improvement';

                if (improvement.otherImprovement) {
                    improvementName = `${improvement.otherImprovement.value}`;
                }

                option.elements = [];

                option.elements.push({ code: 'Label', value: improvementName });

                improvements.push(option);
            });
        }

        return improvements;
    };

    const dwellingName =
        props.dwelling?.construction?.yearBuilt && props.dwelling.construction.type
            ? `${props.dwelling.construction.yearBuilt} ${props.dwelling.construction.type.value}`
            : `Dwelling ${props.dwelling?.number}`;

    return (
        <React.Fragment>
            {mode === 'dwelling' && (
                <React.Fragment>
                    <BackButton clickEvent={props.backEvent} />
                    <Divider top={sizes.md} />
                    <Header size={sizes.md} textAlign={alignments.left} text={dwellingName} />
                    <Form
                        label={<FormattedMessage id='Profile_Dwellings_Dwelling.dwellingDetails' />}
                        allowEdit={props.allowEdit}
                        saveEvent={() => props.doUpsertPolicy()}
                        cancelEvent={() => props.doGetPolicy()}
                    >
                        <FormInput
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.number' />}
                            value={props.dwelling?.number}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({ code: `${props.dotProp}number`, value })
                            }
                            allowEdit
                        />
                        <FormRadio
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.principalUnit' />}
                            value={{
                                code: convertFromBoolean(props.dwelling?.principalUnit || false),
                            }}
                            references={props.reference.references?.YesNo}
                            referencesEvent={() => props.reference.doGetReferences('YesNo')}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}principalUnit`,
                                    value: convertToBoolean(value.code),
                                })
                            }
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.replacementCost' />}
                            value={props.dwelling?.replacementCost?.value}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({ code: `${props.dotProp}replacementCost.value`, value })
                            }
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id={'Profile_Dwellings_Dwelling.numberOfLossPayees'} />}
                            value={props.dwelling?.numberOfLossPayees}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({ code: `${props.dotProp}numberOfLossPayees`, value })
                            }
                            allowEdit
                        />
                    </Form>
                    <AddressForm
                        {...props}
                        enableAddressSearch
                        addressSearchCountryCode={'USA'}
                        label={<FormattedMessage id='Profile_Dwellings_Dwelling.dwellingAddress' />}
                        saveEvent={props.doUpsertPolicy}
                        cancelEvent={props.doGetPolicy}
                        reference={props.reference}
                        changeEvent={(dotProp, value) => {
                            dotProp === 'address'
                                ? props.doReducePolicyElement({ code: `${props.dotProp}address`, value })
                                : props.doReducePolicyElement({ code: `${props.dotProp}address.${dotProp}`, value });
                        }}
                        allowEdit
                        address={props.dwelling?.address}
                    />
                    <Form
                        label={<FormattedMessage id='Profile_Dwellings_Dwelling.construction' />}
                        allowEdit={props.allowEdit}
                        saveEvent={() => props.doUpsertPolicy()}
                        cancelEvent={() => props.doGetPolicy()}
                    >
                        <FormDropDown
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.dwellingType' />}
                            value={props.dwelling?.construction?.type}
                            references={props.reference.references?.DwellingType}
                            referencesEvent={() => props.reference.doGetReferences('DwellingType')}
                            changeEvent={(value) =>
                                setAttributeEntity(
                                    `${props.dotProp}construction.type`,
                                    value,
                                    props.doReducePolicyElement,
                                )
                            }
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.yearBuilt' />}
                            value={props.dwelling?.construction?.yearBuilt}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({ code: `${props.dotProp}construction.yearBuilt`, value })
                            }
                            allowEdit
                        />
                        <FormDropDown
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.wallFraming' />}
                            value={props.dwelling?.construction?.wallFramingType}
                            references={props.reference.references?.WallFinish}
                            referencesEvent={() => props.reference.doGetReferences('WallFinish')}
                            changeEvent={(value) =>
                                setAttributeEntity(
                                    `${props.dotProp}construction.wallFramingType`,
                                    value,
                                    props.doReducePolicyElement,
                                )
                            }
                            allowEdit
                        />
                        <FormDropDown
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.wallExterior' />}
                            value={props.dwelling?.construction?.wallExteriorType}
                            references={props.reference.references?.ExteriorWallFinish}
                            referencesEvent={() => props.reference.doGetReferences('ExteriorWallFinish')}
                            changeEvent={(value) =>
                                setAttributeEntity(
                                    `${props.dotProp}construction.wallExteriorType`,
                                    value,
                                    props.doReducePolicyElement,
                                )
                            }
                            allowEdit
                        />
                        <FormDropDown
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.roofMaterial' />}
                            value={
                                props.dwelling?.construction?.roofingMaterials &&
                                props.dwelling.construction.roofingMaterials.length > 0 &&
                                props.dwelling.construction.roofingMaterials[0]?.type
                            }
                            references={props.reference.references?.RoofType}
                            referencesEvent={() => props.reference.doGetReferences('RoofType')}
                            changeEvent={(value) => {
                                if (
                                    props.dwelling?.construction?.roofingMaterials &&
                                    props.dwelling.construction.roofingMaterials.length > 0 &&
                                    props.dwelling.construction.roofingMaterials[0]?.type
                                ) {
                                    setAttributeEntity(
                                        `${props.dotProp}construction.roofingMaterials.0.type`,
                                        value,
                                        props.doReducePolicyElement,
                                    );
                                } else {
                                    props.doReducePolicyElement({
                                        code: `${props.dotProp}construction.roofingMaterials`,
                                        value: [{ type: { code: value.code, value: value.value } }],
                                    });
                                }
                            }}
                            allowEdit
                        />
                        <FormDropDown
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.roofRenovationType' />}
                            value={props.dwelling?.improvement?.roofingImprovement}
                            references={props.reference.references?.RenovationType}
                            referencesEvent={() => props.reference.doGetReferences('RenovationType')}
                            changeEvent={(value) =>
                                setAttributeEntity(
                                    `${props.dotProp}improvement.roofingImprovement`,
                                    value,
                                    props.doReducePolicyElement,
                                )
                            }
                            allowEdit
                        />
                        {props.dwelling?.improvement?.roofingImprovement &&
                            (props.dwelling.improvement.roofingImprovement.code === undefined ||
                                props.dwelling.improvement.roofingImprovement.value !== 'None') && (
                                <FormInput
                                    label={<FormattedMessage id='Profile_Dwellings_Dwelling.roofRenovationYear' />}
                                    value={props.dwelling?.improvement?.roofingImprovementYear}
                                    changeEvent={(value) =>
                                        props.doReducePolicyElement({
                                            code: `${props.dotProp}improvement.roofingImprovementYear`,
                                            value,
                                        })
                                    }
                                    allowEdit
                                />
                            )}
                        <FormInput
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.numberOfUnits' />}
                            value={props.dwelling?.construction?.numberOfUnits}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}construction.numberOfUnits`,
                                    value,
                                })
                            }
                            allowEdit
                        />
                        <FormDropDown
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.numberOfStories' />}
                            value={props.dwelling?.construction?.numberOfStories}
                            references={props.reference.references?.Storeys}
                            referencesEvent={() => props.reference.doGetReferences('Storeys')}
                            changeEvent={(value) =>
                                setAttributeEntity(
                                    `${props.dotProp}construction.numberOfStories`,
                                    value,
                                    props.doReducePolicyElement,
                                )
                            }
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.numberOfBathrooms' />}
                            value={props.dwelling?.construction?.numberOfBathrooms}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}construction.numberOfBathrooms`,
                                    value,
                                })
                            }
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.totalLivingArea' />}
                            value={props.dwelling?.construction?.totalLivingArea?.value}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}construction.totalLivingArea.value`,
                                    value,
                                })
                            }
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.finishedBasementPercentage' />}
                            value={props.dwelling?.construction?.basementFinishedPercentage}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}construction.basementFinishedPercentage`,
                                    value,
                                })
                            }
                            allowEdit
                        />
                    </Form>
                    <Form
                        label={<FormattedMessage id='Profile_Dwellings_Dwelling.occupancy' />}
                        allowEdit={props.allowEdit}
                        saveEvent={() => props.doUpsertPolicy()}
                        cancelEvent={() => props.doGetPolicy()}
                    >
                        <FormDropDown
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.occupancyType' />}
                            value={props.dwelling?.occupancy?.type}
                            references={props.reference.references?.OccupancyType}
                            referencesEvent={() => props.reference.doGetReferences('OccupancyType')}
                            changeEvent={(value) =>
                                setAttributeEntity(`${props.dotProp}occupancy.type`, value, props.doReducePolicyElement)
                            }
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.numberOfFamilies' />}
                            value={props.dwelling?.occupancy?.numberOfFamilies}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}occupancy.numberOfFamilies`,
                                    value,
                                })
                            }
                            allowEdit
                        />
                        <FormDropDown
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.businessActivity' />}
                            value={props.dwelling?.occupancy?.residenceBusinessType}
                            references={props.reference.references?.BusinessType}
                            referencesEvent={() => props.reference.doGetReferences('BusinessType')}
                            changeEvent={(value) =>
                                setAttributeEntity(
                                    `${props.dotProp}occupancy.residenceBusinessType`,
                                    value,
                                    props.doReducePolicyElement,
                                )
                            }
                            allowEdit
                        />
                        <FormRadio
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.smokeFree' />}
                            value={
                                props.dwelling?.occupancy && {
                                    code: convertFromBoolean(props.dwelling.occupancy.smokeFree),
                                }
                            }
                            references={props.reference.references?.YesNo}
                            referencesEvent={() => props.reference.doGetReferences('YesNo')}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}occupancy.smokeFree`,
                                    value: convertToBoolean(value.code),
                                })
                            }
                            allowEdit
                        />
                    </Form>
                    <Form
                        label={<FormattedMessage id='Profile_Dwellings_Dwelling.electricalSystem' />}
                        allowEdit={props.allowEdit}
                        saveEvent={() => props.doUpsertPolicy()}
                        cancelEvent={() => props.doGetPolicy()}
                    >
                        <FormDropDown
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.wiringType' />}
                            value={props.dwelling?.construction?.wiringType}
                            references={props.reference.references?.WiringType}
                            referencesEvent={() => props.reference.doGetReferences('WiringType')}
                            changeEvent={(value) =>
                                setAttributeEntity(
                                    `${props.dotProp}construction.wiringType`,
                                    value,
                                    props.doReducePolicyElement,
                                )
                            }
                            allowEdit
                        />
                        <FormDropDown
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.panelType' />}
                            value={props.dwelling?.construction?.electricalPanelType}
                            references={props.reference.references?.ElectricalPanel}
                            referencesEvent={() => props.reference.doGetReferences('ElectricalPanel')}
                            changeEvent={(value) =>
                                setAttributeEntity(
                                    `${props.dotProp}construction.electricalPanelType`,
                                    value,
                                    props.doReducePolicyElement,
                                )
                            }
                            allowEdit
                        />
                        <FormDropDown
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.strength' />}
                            value={
                                props.dwelling?.construction?.electricalStrength && {
                                    code: `${props.dwelling.construction.electricalStrength.value}`,
                                }
                            }
                            references={props.reference.references?.Ampers}
                            referencesEvent={() => props.reference.doGetReferences('Ampers')}
                            changeEvent={(value) => {
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}construction.electricalStrength.value`,
                                    value: value.code,
                                });
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}construction.electricalStrength.type`,
                                    value: 'A',
                                });
                            }}
                            allowEdit
                        />
                        <FormDropDown
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.wiringRenovationType' />}
                            value={props.dwelling?.improvement?.wiringImprovement}
                            references={props.reference.references?.RenovationType}
                            referencesEvent={() => props.reference.doGetReferences('RenovationType')}
                            changeEvent={(value) =>
                                setAttributeEntity(
                                    `${props.dotProp}improvement.wiringImprovement`,
                                    value,
                                    props.doReducePolicyElement,
                                )
                            }
                            allowEdit
                        />
                        {props.dwelling?.improvement?.wiringImprovement &&
                            (props.dwelling.improvement.wiringImprovement.code === undefined ||
                                props.dwelling.improvement.wiringImprovement.value !== 'None') && (
                                <FormInput
                                    label={<FormattedMessage id='Profile_Dwellings_Dwelling.wiringRenovationYear' />}
                                    value={props.dwelling?.improvement?.wiringImprovementYear}
                                    changeEvent={(value) =>
                                        props.doReducePolicyElement({
                                            code: `${props.dotProp}improvement.wiringImprovementYear`,
                                            value,
                                        })
                                    }
                                    allowEdit
                                />
                            )}
                    </Form>
                    <Form
                        label={<FormattedMessage id='Profile_Dwellings_Dwelling.waterHeatingSystem' />}
                        allowEdit={props.allowEdit}
                        saveEvent={() => props.doUpsertPolicy()}
                        cancelEvent={() => props.doGetPolicy()}
                    >
                        <FormInput
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.waterTankYear' />}
                            value={props.dwelling?.waterHeatingSystem?.year}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({ code: `${props.dotProp}waterHeatingSystem.year`, value })
                            }
                            allowEdit
                        />
                        <FormDropDown
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.waterPipeMaterial' />}
                            value={props.dwelling?.construction?.plumbingType}
                            references={props.reference.references?.PlumbingType}
                            referencesEvent={() => props.reference.doGetReferences('PlumbingType')}
                            changeEvent={(value) =>
                                setAttributeEntity(
                                    `${props.dotProp}construction.plumbingType`,
                                    value,
                                    props.doReducePolicyElement,
                                )
                            }
                            allowEdit
                        />
                        <FormDropDown
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.plumbingRenovationType' />}
                            value={props.dwelling?.improvement?.plumbingImprovement}
                            references={props.reference.references?.RenovationType}
                            referencesEvent={() => props.reference.doGetReferences('RenovationType')}
                            changeEvent={(value) =>
                                setAttributeEntity(
                                    `${props.dotProp}improvement.plumbingImprovement`,
                                    value,
                                    props.doReducePolicyElement,
                                )
                            }
                            allowEdit
                        />
                        {props.dwelling?.improvement?.plumbingImprovement &&
                            (props.dwelling.improvement.plumbingImprovement.code === undefined ||
                                props.dwelling.improvement.plumbingImprovement.value !== 'None') && (
                                <FormInput
                                    label={<FormattedMessage id='Profile_Dwellings_Dwelling.wiringRenovationYear' />}
                                    value={props.dwelling?.improvement?.plumbingImprovementYear}
                                    changeEvent={(value) =>
                                        props.doReducePolicyElement({
                                            code: `${props.dotProp}improvement.plumbingImprovementYear`,
                                            value,
                                        })
                                    }
                                    allowEdit
                                />
                            )}
                        <FormRadio
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.septicTank' />}
                            value={
                                props.dwelling?.construction && {
                                    code: convertFromBoolean(props.dwelling.construction.septicTank),
                                }
                            }
                            references={props.reference.references?.YesNo}
                            referencesEvent={() => props.reference.doGetReferences('YesNo')}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}construction.septicTank`,
                                    value: convertToBoolean(value.code),
                                })
                            }
                            allowEdit
                        />
                    </Form>
                    <Form
                        label={<FormattedMessage id='Profile_Dwellings_Dwelling.protectionSystems' />}
                        allowEdit={props.allowEdit}
                        saveEvent={() => props.doUpsertPolicy()}
                        cancelEvent={() => props.doGetPolicy()}
                    >
                        <FormInput
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.distanceToFireHydrant' />}
                            value={props.dwelling?.protection?.distanceToHydrant?.value}
                            changeEvent={(value) => {
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}protection.distanceToHydrant.value`,
                                    value,
                                });
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}protection.distanceToHydrant.type`,
                                    value: 'm',
                                });
                            }}
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.distanceToFireStation' />}
                            value={props.dwelling?.protection?.distanceToFireStation?.value}
                            changeEvent={(value) => {
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}protection.distanceToFireStation.value`,
                                    value,
                                });
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}protection.distanceToFireStation.type`,
                                    value: 'km',
                                });
                            }}
                            allowEdit
                        />
                        <FormDropDown
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.fireAlarm' />}
                            value={props.dwelling?.protection?.fireDevice}
                            references={props.reference.references?.FireDevice}
                            referencesEvent={() => props.reference.doGetReferences('FireDevice')}
                            changeEvent={(value) =>
                                setAttributeEntity(
                                    `${props.dotProp}protection.fireDevice`,
                                    value,
                                    props.doReducePolicyElement,
                                )
                            }
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.numberOfSmokeDetectors' />}
                            value={props.dwelling?.protection?.numberOfSmokeAlarms}
                            changeEvent={(value) => {
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}protection.numberOfSmokeAlarms`,
                                    value,
                                });
                            }}
                            allowEdit
                        />
                        <FormRadio
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.sprinklers' />}
                            value={
                                props.dwelling?.protection && {
                                    code: convertFromBoolean(props.dwelling.protection.sprinklers),
                                }
                            }
                            references={props.reference.references?.YesNo}
                            referencesEvent={() => props.reference.doGetReferences('YesNo')}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}protection.sprinklers`,
                                    value: convertToBoolean(value.code),
                                })
                            }
                            allowEdit
                        />
                        {props.dwelling?.protection && props.dwelling.protection.sprinklers === true && (
                            <FormRadio
                                label={<FormattedMessage id='Profile_Dwellings_Dwelling.sprinklerCoverage' />}
                                value={props.dwelling?.protection?.sprinklersCoverage}
                                references={props.reference.references?.RenovationType}
                                referencesEvent={() => props.reference.doGetReferences('RenovationType')}
                                changeEvent={(value) =>
                                    setAttributeEntity(
                                        `${props.dotProp}protection.sprinklersCoverage`,
                                        value,
                                        props.doReducePolicyElement,
                                    )
                                }
                                allowEdit
                            />
                        )}
                        <FormDropDown
                            label={<FormattedMessage id='Profile_Dwellings_Dwelling.burglaryAlarm' />}
                            value={props.dwelling?.protection?.burglarDevice}
                            references={props.reference.references?.BurglaryDevice}
                            referencesEvent={() => props.reference.doGetReferences('BurglaryDevice')}
                            changeEvent={(value) =>
                                setAttributeEntity(
                                    `${props.dotProp}protection.burglarDevice`,
                                    value,
                                    props.doReducePolicyElement,
                                )
                            }
                            allowEdit
                        />
                    </Form>

                    <Divider top={sizes.xl} />
                    <Header
                        size={sizes.lg}
                        textAlign={alignments.left}
                        text={<FormattedMessage id='Profile_Dwellings_Dwelling.waterMitigationSystems' />}
                    />
                    <Container top={sizes.xl} bottom={sizes.xl}>
                        <SummaryGroup
                            allowAdd={props.allowEdit}
                            addEvent={() => {
                                props.doReduceParameter({ code: 'Dwelling', value: props.dwelling.guid });
                                props.doExecutePolicyAction({ code: 'CREATEDWELLINGWATERMITIGATION' });
                            }}
                            allowEdit
                            editEvent={(waterMitigationSystem) => {
                                setCurrent(waterMitigationSystem);
                                setMode('waterMitigationSystem');
                            }}
                            allowDelete={props.allowEdit}
                            deleteEvent={(waterMitigationSystem) => {
                                props.doReduceParameter({ code: 'Dwelling', value: props.dwelling.guid });
                                props.doReduceParameter({
                                    code: 'DwellingWaterMitigation',
                                    value: waterMitigationSystem,
                                });
                                props.doExecutePolicyAction({ code: 'DELETEDWELLINGWATERMITIGATION' });
                                setCurrent(null);
                                setMode('dwelling');
                            }}
                            entities={getDwellingWaterMitigationSystems()}
                            icon={'waterMitigation'}
                        />
                    </Container>
                    <Divider top={sizes.xl} />
                    <Header
                        size={sizes.lg}
                        textAlign={alignments.left}
                        text={<FormattedMessage id='Profile_Dwellings_Dwelling.heatingSystems' />}
                    />
                    <Container top={sizes.xl} bottom={sizes.xl}>
                        <SummaryGroup
                            allowAdd={props.allowEdit}
                            addEvent={() => {
                                props.doReduceParameter({ code: 'Dwelling', value: props.dwelling.guid });
                                props.doExecutePolicyAction({ code: 'CREATEDWELLINGHEATINGSYSTEM' });
                            }}
                            allowEdit
                            editEvent={(heatingSystem) => {
                                setCurrent(heatingSystem);
                                setMode('heatingSystem');
                            }}
                            allowDelete={props.allowEdit}
                            deleteEvent={(heatingSystem) => {
                                props.doReduceParameter({ code: 'Dwelling', value: props.dwelling.guid });
                                props.doReduceParameter({ code: 'DwellingHeatingSystem', value: heatingSystem });
                                props.doExecutePolicyAction({ code: 'DELETEDWELLINGHEATINGSYSTEM' });
                                setCurrent(null);
                                setMode('dwelling');
                            }}
                            entities={getDwellingHeatingSystems()}
                            icon={'heatingSystem'}
                        />
                    </Container>
                    <Divider top={sizes.xl} />
                    <Header
                        size={sizes.lg}
                        textAlign={alignments.left}
                        text={<FormattedMessage id='Profile_Dwellings_Dwelling.garages' />}
                    />
                    <Container top={sizes.xl} bottom={sizes.xl}>
                        <SummaryGroup
                            allowAdd={props.allowEdit}
                            addEvent={() => {
                                props.doReduceParameter({ code: 'Dwelling', value: props.dwelling.guid });
                                props.doExecutePolicyAction({ code: 'CREATEDWELLINGGARAGE' });
                            }}
                            allowEdit
                            editEvent={(garage) => {
                                setCurrent(garage);
                                setMode('garage');
                            }}
                            allowDelete={props.allowEdit}
                            deleteEvent={(garage) => {
                                props.doReduceParameter({ code: 'Dwelling', value: props.dwelling.guid });
                                props.doReduceParameter({ code: 'DwellingGarage', value: garage });
                                props.doExecutePolicyAction({ code: 'DELETEDWELLINGGARAGE' });
                                setCurrent(null);
                                setMode('dwelling');
                            }}
                            entities={getDwellingGarages()}
                            icon={'garage'}
                        />
                    </Container>
                    <Divider top={sizes.xl} />
                    <Header
                        size={sizes.lg}
                        textAlign={alignments.left}
                        text={<FormattedMessage id='Profile_Dwellings_Dwelling.swimmingPools' />}
                    />
                    <Container top={sizes.xl} bottom={sizes.xl}>
                        <SummaryGroup
                            allowAdd={props.allowEdit}
                            addEvent={() => {
                                props.doReduceParameter({ code: 'Dwelling', value: props.dwelling.guid });
                                props.doExecutePolicyAction({ code: 'CREATEDWELLINGSWIMMINGPOOL' });
                            }}
                            allowEdit
                            editEvent={(swimmingPool) => {
                                setCurrent(swimmingPool);
                                setMode('swimmingPool');
                            }}
                            allowDelete={props.allowEdit}
                            deleteEvent={(swimmingPool) => {
                                props.doReduceParameter({ code: 'Dwelling', value: props.dwelling.guid });
                                props.doReduceParameter({ code: 'DwellingSwimmingPool', value: swimmingPool });
                                props.doExecutePolicyAction({ code: 'DELETEDWELLINGSWIMMINGPOOL' });
                                setCurrent(null);
                                setMode('dwelling');
                            }}
                            entities={getDwellingSwimmingPools()}
                            icon={'swimmingPool'}
                        />
                    </Container>
                    <Divider top={sizes.xl} />
                    <Header
                        size={sizes.lg}
                        textAlign={alignments.left}
                        text={<FormattedMessage id='Profile_Dwellings_Dwelling.scheduledItems' />}
                    />
                    <Container top={sizes.xl} bottom={sizes.xl}>
                        <SummaryGroup
                            allowAdd={props.allowEdit}
                            addEvent={() => {
                                props.doReduceParameter({ code: 'Dwelling', value: props.dwelling.guid });
                                props.doExecutePolicyAction({ code: 'CREATEDWELLINGSCHEDULEDITEM' });
                            }}
                            allowEdit
                            editEvent={(scheduledItem) => {
                                setCurrent(scheduledItem);
                                setMode('scheduledItem');
                            }}
                            allowDelete={props.allowEdit}
                            deleteEvent={(scheduledItem) => {
                                props.doReduceParameter({ code: 'Dwelling', value: props.dwelling.guid });
                                props.doReduceParameter({ code: 'DwellingScheduledItem', value: scheduledItem });
                                props.doExecutePolicyAction({ code: 'DELETEDWELLINGSCHEDULEDITEM' });
                                setCurrent(null);
                                setMode('dwelling');
                            }}
                            entities={getDwellingScheduledItems()}
                            icon={'scheduledItem'}
                        />
                    </Container>
                    <Divider top={sizes.xl} />
                    <Header
                        size={sizes.lg}
                        textAlign={alignments.left}
                        text={<FormattedMessage id='Profile_Dwellings_Dwelling.improvements' />}
                    />
                    <Container top={sizes.xl} bottom={sizes.xl}>
                        <SummaryGroup
                            allowAdd={props.allowEdit}
                            addEvent={() => {
                                props.doReduceParameter({ code: 'Dwelling', value: props.dwelling.guid });
                                props.doExecutePolicyAction({ code: 'CREATEDWELLINGOTHERIMPROVEMENT' });
                            }}
                            allowEdit
                            editEvent={(improvement) => {
                                setCurrent(improvement);
                                setMode('improvement');
                            }}
                            allowDelete={props.allowEdit}
                            deleteEvent={(improvement) => {
                                props.doReduceParameter({ code: 'Dwelling', value: props.dwelling.guid });
                                props.doReduceParameter({ code: 'DwellingOtherImprovement', value: improvement });
                                props.doExecutePolicyAction({ code: 'DELETEDWELLINGOTHERIMPROVEMENT' });
                                setCurrent(null);
                                setMode('dwelling');
                            }}
                            entities={getDwellingImprovements()}
                            icon={'highValueImprovement'}
                        />
                    </Container>
                    <Divider top={sizes.xl} />
                    <Header
                        size={sizes.lg}
                        textAlign={alignments.left}
                        text={<FormattedMessage id='Profile_Dwellings_Dwelling.lossPayees' />}
                    />
                    <Container top={sizes.xl} bottom={sizes.xl}>
                        <SummaryGroup
                            allowAdd={props.allowEdit}
                            addEvent={() => {
                                props.doReduceParameter({ code: 'Dwelling', value: props.dwelling.guid });
                                props.doExecutePolicyAction({ code: 'CREATEDWELLINGLOSSPAYEE' });
                            }}
                            allowEdit
                            editEvent={(lossPayee) => {
                                setCurrent(lossPayee);
                                setMode('lossPayee');
                            }}
                            allowDelete={props.allowEdit}
                            deleteEvent={(lossPayee) => {
                                props.doReduceParameter({ code: 'Dwelling', value: props.dwelling.guid });
                                props.doReduceParameter({ code: 'DwellingLossPayee', value: lossPayee });
                                props.doExecutePolicyAction({ code: 'DELETEDWELLINGLOSSPAYEE' });
                                setCurrent(null);
                                setMode('dwelling');
                            }}
                            entities={getDwellingLossPayees()}
                            icon={'mortgage'}
                        />
                    </Container>
                    <Divider top={sizes.xl} />
                    <Header
                        size={sizes.lg}
                        textAlign={alignments.left}
                        text={<FormattedMessage id='Profile_Dwellings_Dwelling.animals' />}
                    />
                    <Container top={sizes.xl} bottom={sizes.xl}>
                        <SummaryGroup
                            allowAdd={props.allowEdit}
                            addEvent={() => {
                                props.doReduceParameter({ code: 'Dwelling', value: props.dwelling.guid });
                                props.doExecutePolicyAction({ code: 'CREATEDWELLINGANIMAL' });
                            }}
                            allowEdit
                            editEvent={(animal) => {
                                setCurrent(animal);
                                setMode('animal');
                            }}
                            allowDelete={props.allowEdit}
                            deleteEvent={(animal) => {
                                props.doReduceParameter({ code: 'Dwelling', value: props.dwelling.guid });
                                props.doReduceParameter({ code: 'DwellingAnimal', value: animal });
                                props.doExecutePolicyAction({ code: 'DELETEDWELLINGANIMAL' });
                                setCurrent(null);
                                setMode('dwelling');
                            }}
                            entities={getDwellingAnimals()}
                            icon={'pet'}
                        />
                    </Container>
                </React.Fragment>
            )}
            {mode === 'waterMitigationSystem' && (
                <ProfileDwellingWaterMitigationSystem
                    waterMitigationSystem={props.dwelling.protection.waterMitigations.find((x) => x.guid === current)}
                    allowPrimary={
                        !props.dwelling.protection.waterMitigations.some((x) => x.primary === true) ||
                        props.dwelling.protection.waterMitigations.find((x) => x.guid === current).primary
                    }
                    dotProp={`${props.dotProp}protection.waterMitigations.${props.dwelling.protection.waterMitigations.findIndex((x) => x.guid === current)}.`}
                    backEvent={() => {
                        setMode('dwelling');
                        setCurrent(null);
                    }}
                    doUpsertPolicy={props.doUpsertPolicy}
                    doGetPolicy={props.doGetPolicy}
                    doReducePolicyElement={props.doReducePolicyElement}
                    reference={props.reference}
                    context={props.context}
                    allowEdit={props.allowEdit}
                />
            )}
            {mode === 'heatingSystem' && (
                <ProfileDwellingHeatingSystem
                    heatingSystem={props.dwelling.heatingSystems.find((x) => x.guid === current)}
                    allowPrimary={
                        !props.dwelling.heatingSystems.some((x) => x.primary === true) ||
                        props.dwelling.heatingSystems.find((x) => x.guid === current).primary
                    }
                    improvement={props.dwelling?.improvement}
                    dotProp={`${props.dotProp}heatingSystems.${props.dwelling.heatingSystems.findIndex((x) => x.guid === current)}.`}
                    baseDotProp={props.dotProp}
                    backEvent={() => {
                        setMode('dwelling');
                        setCurrent(null);
                    }}
                    doUpsertPolicy={props.doUpsertPolicy}
                    doGetPolicy={props.doGetPolicy}
                    doReducePolicyElement={props.doReducePolicyElement}
                    reference={props.reference}
                    context={props.context}
                    allowEdit={props.allowEdit}
                />
            )}
            {mode === 'garage' && (
                <ProfileDwellingGarage
                    garage={props.dwelling.garages.find((x) => x.guid === current)}
                    dotProp={`${props.dotProp}garages.${props.dwelling.garages.findIndex((x) => x.guid === current)}.`}
                    backEvent={() => {
                        setMode('dwelling');
                        setCurrent(null);
                    }}
                    doUpsertPolicy={props.doUpsertPolicy}
                    doGetPolicy={props.doGetPolicy}
                    doReducePolicyElement={props.doReducePolicyElement}
                    reference={props.reference}
                    context={props.context}
                    allowEdit={props.allowEdit}
                />
            )}
            {mode === 'swimmingPool' && (
                <ProfileDwellingSwimmingPool
                    swimmingPool={props.dwelling.swimmingPools.find((x) => x.guid === current)}
                    dotProp={`${props.dotProp}swimmingPools.${props.dwelling.swimmingPools.findIndex((x) => x.guid === current)}.`}
                    backEvent={() => {
                        setMode('dwelling');
                        setCurrent(null);
                    }}
                    doUpsertPolicy={props.doUpsertPolicy}
                    doGetPolicy={props.doGetPolicy}
                    doReducePolicyElement={props.doReducePolicyElement}
                    reference={props.reference}
                    context={props.context}
                    allowEdit={props.allowEdit}
                />
            )}
            {mode === 'improvement' && (
                <ProfileDwellingImprovement
                    improvement={props.dwelling.improvement.otherImprovements.find((x) => x.guid === current)}
                    dotProp={`${props.dotProp}improvement.otherImprovements.${props.dwelling.improvement.otherImprovements.findIndex((x) => x.guid === current)}.`}
                    backEvent={() => {
                        setMode('dwelling');
                        setCurrent(null);
                    }}
                    doUpsertPolicy={props.doUpsertPolicy}
                    doGetPolicy={props.doGetPolicy}
                    doReducePolicyElement={props.doReducePolicyElement}
                    reference={props.reference}
                    context={props.context}
                    allowEdit={props.allowEdit}
                />
            )}
            {mode === 'scheduledItem' && (
                <ProfileDwellingScheduledItem
                    scheduledItem={props.dwelling.scheduledItems.find((x) => x.guid === current)}
                    dotProp={`${props.dotProp}scheduledItems.${props.dwelling.scheduledItems.findIndex((x) => x.guid === current)}.`}
                    backEvent={() => {
                        setMode('dwelling');
                        setCurrent(null);
                    }}
                    doUpsertPolicy={props.doUpsertPolicy}
                    doGetPolicy={props.doGetPolicy}
                    doReducePolicyElement={props.doReducePolicyElement}
                    reference={props.reference}
                    context={props.context}
                    allowEdit={props.allowEdit}
                />
            )}
            {mode === 'lossPayee' && (
                <ProfileDwellingLossPayee
                    lossPayee={props.dwelling.lossPayees.find((x) => x.guid === current)}
                    dotProp={`${props.dotProp}lossPayees.${props.dwelling.lossPayees.findIndex((x) => x.guid === current)}`}
                    backEvent={() => {
                        setMode('dwelling');
                        setCurrent(null);
                    }}
                    doUpsertPolicy={props.doUpsertPolicy}
                    doGetPolicy={props.doGetPolicy}
                    doReducePolicyElement={props.doReducePolicyElement}
                    reference={props.reference}
                    context={props.context}
                    allowEdit={props.allowEdit}
                />
            )}
            {mode === 'animal' && (
                <ProfileDwellingAnimal
                    animal={props.dwelling.animals.find((x) => x.guid === current)}
                    dotProp={`${props.dotProp}animals.${props.dwelling.animals.findIndex((x) => x.guid === current)}.`}
                    backEvent={() => {
                        setMode('dwelling');
                        setCurrent(null);
                    }}
                    doUpsertPolicy={props.doUpsertPolicy}
                    doGetPolicy={props.doGetPolicy}
                    doReducePolicyElement={props.doReducePolicyElement}
                    reference={props.reference}
                    context={props.context}
                    allowEdit={props.allowEdit}
                />
            )}
        </React.Fragment>
    );
};

export default ProfileDwelling;
